<input type="file" class="hidden-file-input" accept="image/png, image/jpeg" onclick="this.value = null"
(change)="onFileSelected($event)" #fileUpload required>

<ng-container *ngIf="!editingEvents">
    <h2>{{selectedEvent?.name}}</h2>
    <p><label class="fixed-size">Name:</label> <strong>{{selectedEvent?.name}}</strong></p>
    <p><label class="fixed-size">Description:</label> <label class="indent"><strong>{{selectedEvent?.description}}</strong></label></p>

    <button class="primary-button" type="add" (click)="this.editEvents()">Edit Events</button>
</ng-container>
<ng-container *ngIf="editingEvents">
    <h2>Editing:  {{selectedEvent?.name}}<button class="delete-button" type="delete" (click)="this.removeEvents()">Delete Events</button></h2>
    <br>
    <form [formGroup]="eventsForm">
        <label class="fixed-size" for="name">Name: </label>
        <input id="name" type="text" formControlName="name">
        <br>
        <div *ngIf="newFile != undefined; else noFile">
          <label class="fixed-size" for="events-image">Events Image: </label>
          <label>{{newFileName}}</label><button class="remove-button" (click)="removeFile()">x</button>
        </div>
        <ng-template #noFile>
          <label  for="events-image">Replace Events Image: </label>
          <button class="add-button" (click)="fileUpload.click()">New Image</button>
        </ng-template>
        <br>
        <label for="description">Description: </label><br>
        <textarea class="text-area-90" style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="10" cols="40"
          formControlName="description"></textarea>
        <br>
      </form>
      <form [formGroup]="eventsForm" (ngSubmit)="submitEventsEdits()"></form>
      <button class="cancel-button" type="cancel" (click)="this.cancelClicked()">Cancel</button>
      <button class="primary-button" type="submit" [disabled]="!eventsForm.valid" (click)="this.submitEventsEdits()">Submit</button>
</ng-container>